import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from 'persianjs'

import { PureComponent, Form, GroupBox } from 'core/components';
import { withLocale, withAuth } from 'core/decorators';
import { Icon, List, ListInput, Button, Row, Col, ListItem, CardContent } from 'core/components/Framework7';

import classes from './styles.module.css';

class Login extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      password: '',
    }
  }

  get initialValue() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.viewProfile,
    }
  }

  static get defaultProps() {
    return {

    }
  }

  handleError() {
    const { username, password } = this.state;

    if (!username || !password) return true

    return false
  }

  handleLogin() {
    const { username, password } = this.state;

    const model = {
      username,
      password
    }

    // return this.props.submit && this.props.submit(model)
    this.props.submit && this.props.submit(model);
  }

  handleRegister() {
    console.log(this.popup)
  }

  handleForgetPassword() {
    this.props.forget && this.props.forget()
  }

  handleUsername(e) {
    // console.log(e.target.value)
    if (!e.target.value || e.target.value == "") {
      this.setState({
        username: ''
      })

      return
    }

    this.setState({
      username: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  handlePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  onSubmit(e) {
    e.preventDefault();
  }

  hasError() {
    const { username, password } = this.state;
    return !((username.length == 10 || username.length == 11) && (password.length >= 4))
  }

  render() {
    const { username, password } = this.state
    const { view } = this.props
    const env = this.initialValue;
    // console.log('view:', view)

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='اطلاعات ورود به حساب کاربری'>
            <CardContent>
              <List noHairlinesMd>
                <ListInput
                  type="tel"
                  clearButton
                  required
                  validate
                  floatingLabel
                  value={username}
                  label={'شماره تلفن همراه'}
                  placeholder="شماره تلفن همراه خود را وارد کنید"
                  info={'مانند ۰۹۱۲۳۴۵۶۷۸۹'}
                  errorMessage={'لطفا شماره تلفن همراه خود را وارد کنید'}
                  onInputClear={() => this.setState({ username: '' })}
                  onChange={this.handleUsername}
                  className={classes.input}
                >
                  <Icon icon="mdi-phone" slot="media" />
                </ListInput>
                <ListInput
                  type="password"
                  floatingLabel
                  clearButton
                  required
                  validate
                  value={password}
                  label={'رمز عبور'}
                  placeholder="رمز عبور را وارد کنید"
                  info={'اجباری'}
                  errorMessage={'لطفا رمز عبور خود را وارد کنید'}
                  onInputClear={() => this.setState({ password: '' })}
                  onChange={this.handlePassword}
                  className={classes.input}
                >
                  <Icon icon="mdi-account-key" slot="media" />
                </ListInput>
              </List>
            </CardContent>
          </GroupBox>

          <GroupBox outline className={classes.itemLinks}>
            <CardContent>
              <List noHairlinesMd>
                <ListItem
                  link="/register"
                  view={view}
                  title="ثبت نام کنید"
                  popupClose={'#popup-profile-page'}
                // onClick={this.handleRegister}
                >
                  <Icon slot="media" icon="mdi-account-plus" />
                </ListItem>
                <ListItem
                  link="/forget_password"
                  view={view}
                  title="رمز عبور خود را فراموش کرده‌ام"
                  popupClose={'#popup-profile-page'}
                  // onClick={this.handleForgetPassword}
                >
                  <Icon slot="media" icon="mdi-account-question" />
                </ListItem>
              </List>
            </CardContent>
          </GroupBox>

          {env.page.description && env.page.description.length > 0 &&
            <GroupBox outline title={'توضیحات'}>
              <CardContent>
                {
                  env.page.description.map((text, index) => {
                    return <div key={index}>{`- ${text}`}</div>
                  })
                }
              </CardContent>
            </GroupBox>
          }
        </div>
        <Button large fill
          type='submit'
          icon="mdi-login"
          text={'ورود به حساب کاربری'}
          className={classes.fullWidthButton}
          disabled={this.hasError()}
          onClick={this.handleLogin}
        />
      </form>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {

  }
)(withLocale('login')(withAuth(autobind(Login))))